
//统一域名地址
const domain = process.env.NODE_ENV === 'production'
    ? 'https://www.yixingauto.com'
    : 'https://www.yixingauto.com';

//项目配置
const _config = {
    //项目路由前缀
    prefix: '',
    domain: domain
}

export default _config
